export default __webpack_public_path__ + "static/media/pvilla5-2.525a29ab.webp";